module.exports = __webpack_public_path__ + "static/media/brick-background.c19705bd.jpeg";